module.exports = __webpack_public_path__ + "static/24-f531a0f9a6734f3dc645b4d99f585a6d.png";